import { gql } from '@apollo/client';

import { User, Conversation, ConversationMessage } from '../../types';

export interface RequestConversation {
  conversations: Array<
    Pick<Conversation, 'uuid'> & {
      conversations_messages: Array<
        Pick<ConversationMessage, 'content' | 'type'> & {
          users: Pick<User, 'firstName'>;
        }
      >;
    }
  >;
}

export const REQUEST_CONVERSATION = gql`
  query conversations(
    $event_request_id: String
    $supplier_id: String
    $userId: String
  ) {
    conversations(
      where: {
        event_request_id: { equals: $event_request_id }
        supplier_id: { equals: $supplier_id }
      }
    ) {
      uuid
      conversations_messages(
        where: {
          type: { in: [auto, regular, newPrice, attachment] }
          sender_user_id: { not: { equals: $userId } }
          conversations_read_receipts: {
            none: { recipient: { equals: $userId } }
          }
        }
        take: 1
        orderBy: { created: desc }
      ) {
        content
        type
        users {
          firstName
        }
      }
    }
  }
`;
